import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { QuantityForColor } from 'swag-client-common/components/partials/quantity-for-color';
import { ColorLabel } from 'swag-client-common/components/ui/color-label';
import { QuantityPerSize } from 'swag-client-common/components/partials/quantity-per-size';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import BottomButtons from '../cart-box-builder-popup/components/bottom-buttons';
import errorAnimationClasses from './error.anim.scss';
import css from './edit-quantity-in-cart-for-build-boxes-drawer.scss';
const titleClasses = {
  root: css.header
};
const classes = {
  paper: css.paper,
  root: css.root
};
const EditQuantityInCartForBuildBoxesDrawer = ({
  errorMessage,
  onSave,
  productIsAlwaysInStock,
  stockLevelsByVariantSku,
  onClose,
  isOpen,
  variant,
  onQuantitiesChange,
  sizes,
  isApparel,
  sizeInd,
  offsetQuantities
}) => {
  const content = variant && /*#__PURE__*/React.createElement("div", {
    className: css.wrapper
  }, /*#__PURE__*/React.createElement("header", {
    className: css.header
  }, "Adjust quantity!"), /*#__PURE__*/React.createElement("div", {
    className: css.quantitiesWrapper
  }, isApparel ? /*#__PURE__*/React.createElement("div", {
    className: css.multipleQuantities
  }, /*#__PURE__*/React.createElement("div", {
    className: css.colorLabel
  }, /*#__PURE__*/React.createElement(ColorLabel, {
    colorValue: variant.color,
    colorName: variant.name
  })), /*#__PURE__*/React.createElement("div", {
    className: css.quantityPerSize
  }, /*#__PURE__*/React.createElement(QuantityPerSize, {
    sizeItemClassName: css.sizeItemBlock,
    stockLevelsByVariantSku: stockLevelsByVariantSku,
    productIsAlwaysInStock: productIsAlwaysInStock,
    sizes: sizes,
    variant: variant,
    quantities: variant.quantities,
    sizeItemInputWrapperClassName: css.sizeItemInputWrapperClassName,
    sizeItemLabelClassName: css.sizeItemLabelClassName,
    sizeItemInputClassName: css.sizeItemInputClassName,
    onChange: ({
      value,
      sizeIndex
    }) => {
      if (String(value).length >= 7) {
        return null;
      }
      const newQuantities = [...variant.quantities];
      newQuantities[sizeIndex] = value;
      onQuantitiesChange(newQuantities);
    }
  }))) : /*#__PURE__*/React.createElement(QuantityForColor, {
    productIsAlwaysInStock: productIsAlwaysInStock,
    variant: variant,
    colorValue: variant.color,
    colorName: variant.name,
    quantity: variant.quantities[sizeInd],
    onChange: string => {
      const value = parseInt(String(string || 0), 10);
      const newQuantities = [...variant.quantities];
      newQuantities[sizeInd] = value;
      onQuantitiesChange(newQuantities);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: css.errorMessage
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: errorAnimationClasses,
    key: errorMessage,
    timeout: 250
  }, /*#__PURE__*/React.createElement("div", {
    "data-text": "ErrorMessage"
  }, errorMessage)))), /*#__PURE__*/React.createElement(BottomButtons
  // @todo. auto generated. fix this error
  // @ts-ignore
  , {
    buttonsWrapperClassName: css.buttons,
    onBackButton: onClose,
    isDisabledNextButton: !!errorMessage,
    onNextButton: () => onSave(offsetQuantities),
    backText: "Cancel",
    nextText: "Save"
  }));
  return /*#__PURE__*/React.createElement(PopupDialog, {
    open: isOpen,
    onClose: onClose,
    dataPopup: "EditQuantityInCartForBuildBoxesDrawer",
    content: content,
    classes: classes,
    titleHeader: css.header,
    titleClasses: titleClasses,
    contentClass: css.contentWrapper,
    closeClass: css.closeClass
  });
};
export default EditQuantityInCartForBuildBoxesDrawer;